import { Component, OnInit, ViewChild, QueryList, ViewChildren, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { DBOperation } from '../../../shared/enum';
import { Global, BaoCao } from '../../../shared/global';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Repository } from '../../../services/repository'


import 'jquery'
import 'bootstrap'

import {
  Lists_nguonkinhphi, Lists_nhacungcap, Lists_chuong, Lists_loaikhoan, Lists_tieumuc, Lists_canbo, Lists_caphat, Lists_nghiepvu, Lists_nganhang, Lists_hoatdong, Lists_cmmt, Lists_mathongke,
  tiens_rutdutoan_ck, Lists_doituongtaphop, Lists_doituongtaphop2,

  Lists_vattuhanghoa,
  Lists_nhommucchi,
  Lists_taisancodinh,
  Lists_congcudungcu
} from '../../../routes/menu'
import { load } from '@telerik/kendo-intl';


const swal = require('sweetalert');
@Component({
  selector: 'app-ketoan-rutdutoantgedit',
  templateUrl: './rutdutoantgedit.component.html',
  styleUrls: ['./rutdutoantgedit.component.scss'],
  providers: [ListService, Repository]
})


export class rutdutoantgeditComponent implements OnInit {
  inputloaitiens: any;
  NgoaiTe: boolean = false;
  fixcot: number = 0;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  quyen_themdoituong: boolean = false;
  quyen_themnguon: boolean = false;
  quyen_themchuong: boolean = false;
  quyen_themkhoan: boolean = false;
  quyen_themtieumuc: boolean = false;
  quyen_themcapphat: boolean = false;
  quyen_themnghiepvu: boolean = false;
  quyen_themnganhang: boolean = false;
  quyen_themctmt: boolean = false;
  quyen_themhoatdong: boolean = false;
  quyen_themthongke: boolean = false;
  quyen_themnhommuchi: boolean = false;
  quyen_themvattuhanghoa: boolean = false;
  quyen_themtaisan: boolean = false;
  quyen_themcongcu: boolean = false;
  quyen_themtaphop: boolean = false;
  quyen_themtaphop2: boolean = false;
  msg: string;
  @ViewChild('modal', { static: false }) modal: ModalComponent;
  @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
  @ViewChild('mdDoiTuongNH', { static: false }) mdDoiTuongNH: ModalComponent;
  @ViewChild('mdCanBo', { static: false }) mdCanBo: ModalComponent;
  @ViewChild('mdLocCamKet', { static: false }) mdLocCamKet: ModalComponent;
  @ViewChild('mdKhachHang', { static: false }) mdKhachhang: ModalComponent;
  @ViewChild('mdLuaChon', { static: false }) mdLuaChon: ModalComponent;
  @ViewChild('slKhachHang', { static: false }) slKhachHang: NgSelectComponent;
  @ViewChild('slTaiKhoanNH', { static: false }) slTaiKhoanNH: NgSelectComponent;
  @ViewChild('slTaiKhoanNH2', { static: false }) slTaiKhoanNH2: NgSelectComponent;
  @ViewChildren(NgSelectComponent) slcombo: QueryList<NgSelectComponent>
  @ViewChild('dteLocCamKet', { static: false }) loccamketedit: any;
  @ViewChild('dtenganhang', { static: false }) nganhangedit: any;
  @ViewChild('dteChung', { static: false }) doituongchungedit: any;
  @ViewChild('dteCanBo', { static: false }) canboedit: any;
  @ViewChild('dteKhachHang', { static: false }) khachhangedit: any;
  @ViewChild('dateQD', { static: false }) dteQD: any;

  @ViewChild('modalthamsogiayrutdutoan02a', { static: false }) modalthamsogiayrutdutoan02a: ModalComponent;
  @ViewChild('dtthamsogiayrutdutoan02aedit', { static: false }) dtthamsogiayrutdutoan02aedit: any;
  @ViewChild('modalthamsogiayrutdutoan02b', { static: false }) modalthamsogiayrutdutoan02b: ModalComponent;
  @ViewChild('dtthamsogiayrutdutoan02bedit', { static: false }) dtthamsogiayrutdutoan02bedit: any;
  @ViewChild('modalthamsobangkethanhtoan_tt39', { static: false }) modalthamsobangkethanhtoan_tt39: ModalComponent;
  @ViewChild('dtbangkethanhtoan_tt39edit', { static: false }) dtbangkethanhtoan_tt39edit: any;
  public currentUser: any;

  datas: Idata[];
  data: Idata;
  indLoading: boolean = false;
  dataFrm: FormGroup;
  dbops: DBOperation;
  modalTitle: string;
  modalBtnTitle: string;
  inputtaikhoans: any;
  inputkhachhangs: any;
  inputnguonkinhphis: any;
  inputchuongs: any;
  inputcaphats: any;
  inputnghiepvus: any;
  inputnganhangs: any;
  inputhoatdongs: any;
  inputcmmts: any;
  inputthongkes: any;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputrutdutoans: any = [{ Id: 1, Ten: "Tạm ứng đã cấp dự toán" }, { Id: 2, Ten: "Tạm ứng chưa cấp dự toán" }, { Id: 3, Ten: "Thực chi" }]
  public ngaychungtu: Date = new Date();
  public ngayghiso: Date = new Date();
  public soquyetdinh: Date = new Date();
  taikhoanno: any = null;
  tendoituong: any = null;
  tabselected: number = 1;
  public mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  @Output() save: EventEmitter<any> = new EventEmitter();
  public loading = true;
  primaryColour: string = '#5d9cec';
  secondaryColour: string = '#ff902b';
  //----------tham số các nhóm cột------------------
  nhomnguonid: string = Lists_nguonkinhphi.id;
  nhomchuongid: string = Lists_chuong.id;
  nhomloaikhoanid: string = Lists_loaikhoan.id;
  nhomtieumucid: string = Lists_tieumuc.id;
  hinhthuccapphatid: string = Lists_caphat.id;
  nghiepvuid: string = Lists_nghiepvu.id;
  nganhangid: string = Lists_nganhang.id;
  hoatdongid: string = Lists_hoatdong.id;
  cmmtid: string = Lists_cmmt.id;
  mathongke: string = Lists_mathongke.id;

  //-----------------------------------------------------

  chungtuSelect: any = {
    Id: null, Don_Vi_Id: null, Ho_Ten: null, Doi_Tuong_Id: null, Ma_Lien_Quan: null, Loai_Rut_Du_Toan: 3, Ma_CKC: null, CKC_Id: null,
    Phan_He_Id: null, Dien_Giai: null, Dia_Chi: null, Ngay_Chung_Tu: null, Ngay_Ghi_So_S: null, Ngay_Chung_Tu_S: null, Ma_Chung_Tu: null, Ngay_Ghi_So: null, Hach_Toan: null, Lien_Quan_Id: null, Tai_Khoan_No_Id: '',
    SoQD: null, NgayQD: null, So_Giay_Rut_Du_Toan: null, Ngay_Giay_Rut_Du_Toan: null, Loai_Nhan_Du_Toan: null, Loai_Phan_Bo_Du_Toan: null, Nghiep_Vu_Rut_Du_Toan: null,
    CTMT_Id: null, Loai_Tien_Id: null, Tai_Khoan_Ngan_Hang1_Id: null, Tai_Khoan_Ngan_Hang2_Id: null, NgayQD_S: null, Ten_Doi_Tuong: null, Ten_Ngan_Hang1: null, So_Tai_Khoan: null, Ten_Ngan_Hang: null,
    ChiTiets: [], DongThois: []
  };
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: true
  };
  onLoaiTienChange($event) {
    const defaultId = "55DBA7D5-A26A-4998-BAC3-4701678E0D11";
    this.NgoaiTe = $event && $event.Id.toUpperCase() !== defaultId;
  }


  donviid: string = null;
  namketoan: number;
  username: string = null;
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private repo: Repository) {


    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.donviid = this.currentUser.id_don_vi;
      this.namketoan = this.currentUser.nam_ke_toan;
      this.username = this.currentUser.user_name;
      var giatri = this.currentUser.ds_quyen.filter(name => name.id === tiens_rutdutoan_ck.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
      // gán quyền thêm đối tượng
      var giatri1 = this.currentUser.ds_quyen.filter(name => name.id === ('532A61EA-D765-844B-8CBF-E610B209E332').toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themdoituong = true;
        else
          this.quyen_themdoituong = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_nguonkinhphi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnguon = true;
        else
          this.quyen_themnguon = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_chuong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themchuong = true;
        else
          this.quyen_themchuong = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_loaikhoan.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themkhoan = true;
        else
          this.quyen_themkhoan = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_tieumuc.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtieumuc = true;
        else
          this.quyen_themtieumuc = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_caphat.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcapphat = true;
        else
          this.quyen_themcapphat = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_nghiepvu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnghiepvu = true;
        else
          this.quyen_themnghiepvu = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_nganhang.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnganhang = true;
        else
          this.quyen_themnganhang = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_cmmt.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themctmt = true;
        else
          this.quyen_themctmt = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_hoatdong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themhoatdong = true;
        else
          this.quyen_themhoatdong = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_mathongke.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themthongke = true;
        else
          this.quyen_themthongke = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_nhommucchi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnhommuchi = true;
        else
          this.quyen_themnhommuchi = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_vattuhanghoa.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themvattuhanghoa = true;
        else
          this.quyen_themvattuhanghoa = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_taisancodinh.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaisan = true;
        else
          this.quyen_themtaisan = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_congcudungcu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcongcu = true;
        else
          this.quyen_themcongcu = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_doituongtaphop.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaphop = true;
        else
          this.quyen_themtaphop = false;
      }
      giatri1 = this.currentUser.ds_quyen.filter(name => name.id === Lists_doituongtaphop2.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaphop2 = true;
        else
          this.quyen_themtaphop2 = false;
      }


    }

  }
  @HostListener('document:keydown', ['$event'])
  public handleKeyboardEvent(event: KeyboardEvent): void {
    if ((event.altKey || event.metaKey) && event.keyCode == 49) {
      this.tabselected = 1;

      setTimeout(() => {
        this.setComboFocus(0, 1, 1);
      }, 500);
    }
    if ((event.altKey || event.metaKey) && event.keyCode == 50) {
      this.tabselected = 2;
      setTimeout(() => {
        this.setComboFocus(0, 1, 2);
      }, 500);
    }
    if ((event.altKey || event.metaKey) && event.keyCode == 51) {
      this.tabselected = 3;
      setTimeout(() => {
        this.setComboFocus(0, 1, 3);
      }, 500);
    }
    event.stopPropagation();

  }
  selectedTab(tab: number) {
    this.tabselected = tab;
    setTimeout(() => {
      this.setComboFocus(0, 1, tab);
    }, 500);
  }
  public innerHeight: any;
  phanheid: string = null;
  //id--ichung tu; loai: đánh dấu trường hợp copy (1: copy, 0: ko),loaick:0 - rút dự toán ck, 1- rút dự toán mua tài sản,
  //ctu: dùng để tạo rút dự toán từ chứng từ trả lương
  loadDataInit(id: string, loai: number, ma_hach_toan: any, hach_toan_id: any, pheid: string, loaick: number, ctu: any) {
    this.innerHeight = window.innerHeight - 290;
    this.ngaychungtu = new Date();
    this.ngayghiso = new Date();
    this.tabselected = 1;
    this.phanheid = pheid;

    this.chungtuSelect = {
      Id: null, Don_Vi_Id: this.donviid, Ho_Ten: null, Doi_Tuong_Id: null, Ma_Lien_Quan: null, Loai_Rut_Du_Toan: 3, Ma_CKC: ma_hach_toan, CKC_Id: hach_toan_id, Loai_CK: loaick,
      Phan_He_Id: this.phanheid, Dien_Giai: null, Dia_Chi: null, Ngay_Chung_Tu: null, Ngay_Ghi_So_S: null, Ngay_Chung_Tu_S: null, Ma_Chung_Tu: null, Ngay_Ghi_So: null, Hach_Toan: null, Lien_Quan_Id: null, Tai_Khoan_No_Id: '',
      SoQD: null, NgayQD: null, So_Giay_Rut_Du_Toan: null, Ngay_Giay_Rut_Du_Toan: null, Loai_Nhan_Du_Toan: null, Loai_Phan_Bo_Du_Toan: null, Nghiep_Vu_Rut_Du_Toan: null,
      CTMT_Id: null, Loai_Tien_Id: null, Tai_Khoan_Ngan_Hang1_Id: null, Tai_Khoan_Ngan_Hang2_Id: null, NgayQD_S: null, Ten_Doi_Tuong: null, Ten_Ngan_Hang1: null, So_Tai_Khoan: null, Ten_Ngan_Hang: null,
      ChiTiets: [], DongThois: []
    };

    if (id === null) {
      if (ctu === null)
      {
        this.repo.getRequest('api/donvicauhinh/thietlapngamdinh/' + this.donviid)
          .subscribe(response => {
            console.log(response);
            this.AddRowNew(this.chungtuSelect.ChiTiets);
            this.chungtuSelect.ChiTiets[0].Nguon_Id = response.Nguon_Id;
            this.chungtuSelect.ChiTiets[0].Loai_Khoan_Id = response.Loai_Khoan_Id;
            this.chungtuSelect.ChiTiets[0].Chuong_Id = response.Chuong_Id;

          });
      }
      else {
        this.chungtuSelect = ctu;
        if (this.chungtuSelect.Ngay_Ghi_So != null) {
          this.ngaychungtu = new Date(this.chungtuSelect.Ngay_Ghi_So);
          this.ngayghiso = new Date(this.chungtuSelect.Ngay_Ghi_So);
        }
        //console.log("tai123231");
        //console.log(ctu);

        //let chuongid = null;
        //this.repo.getRequest('api/donvicauhinh/thietlapngamdinh/' + this.donviid)
        //  .subscribe(response => {
        //    chuongid = response.Chuong_Id;
        //    this.chungtuSelect.ChiTiets.forEach((item: any) => {
        //      if (item.Chuong_Id === null)
        //        item.Chuong_Id = chuongid;
        //    });
        //  });

      }
      if (this.chungtuSelect.Loai_Tien_Id!==null && this.chungtuSelect.Loai_Tien_Id.toUpperCase() !== "55DBA7D5-A26A-4998-BAC3-4701678E0D11")
        this.NgoaiTe = true;
      else
        this.NgoaiTe = false;
     

      if (ctu === null || ctu.Ma_Lien_Quan === null || ctu.Ma_Lien_Quan === "") {
        if (ctu !== null) {
          this.chungtuSelect.Ma_Lien_Quan = ctu.Ma_Chung_Tu;
          this.chungtuSelect.Giao_Dich_Id = ctu.Id;
        }
        this.chungtuSelect.Id = null;
        //{ id: this.donviid, chuoi: tiens_phieuthu.id, status: '2019' }
        this.repo.postRequest("api/chungtu/get_taomachungtuv2/", { id: this.donviid, chuoi: this.phanheid, status: this.namketoan })
          .subscribe(response => {
            //console.log(response[0].Column1);
            if (response != null)
              this.chungtuSelect.Ma_Chung_Tu = response[0].Column1;
          });
      }
      else //trường hợp sửa lại chứng từ phiếu thu từ phiếu rút tiền dự toán
      {
      
        var m_lienquan = this.chungtuSelect.Ma_Lien_Quan;
        var i_lienquan = this.chungtuSelect.Giao_Dich_Id;
        this.chungtuSelect.Ma_Lien_Quan = ctu.Ma_Chung_Tu;
        this.chungtuSelect.Giao_Dich_Id = ctu.Id;
        this.chungtuSelect.Lien_Quan_Id = null;

        this.chungtuSelect.Ma_Chung_Tu = m_lienquan;
        this.chungtuSelect.Id = i_lienquan;
      }
      this.loading = false;
    }
    else {
      this.repo.postRequest("api/chungtu/get_thongtinchungtuv2/", { id: id, status: loai })
        .subscribe(response => {
          console.log(response);
          this.chungtuSelect = response;
          if (this.chungtuSelect.Loai_Tien_Id!==null && this.chungtuSelect.Loai_Tien_Id.toUpperCase() !== "55DBA7D5-A26A-4998-BAC3-4701678E0D11")
            this.NgoaiTe = true;
          else
            this.NgoaiTe = false;
          this.chungtuSelect.Loai_CK = loaick;
          if (loai === 1) {
            let idcopy = this.chungtuSelect.Id;
            this.chungtuSelect.Id = null;
            this.chungtuSelect.Ma_Lien_Quan = null;
            this.chungtuSelect.Lien_Quan_Id = null;
            this.chungtuSelect.Giao_Dich_Id = null;
            this.repo.postRequest("api/chungtu/get_taomachungtuv2/", { id: this.donviid, chuoi: this.phanheid, status: this.namketoan, Chuoi4: idcopy })
              .subscribe(response => {
                //console.log(response[0].Column1);
                if (response != null)
                  this.chungtuSelect.Ma_Chung_Tu = response[0].Column1;

                this.loading = false;
              });
          }
          else
            this.loading = false;
          if (loai === 1) {
            this.ngaychungtu = new Date();
            this.ngayghiso = new Date();
          }
          else {
            this.ngaychungtu = new Date(this.chungtuSelect.Ngay_Chung_Tu);
            this.ngayghiso = new Date(this.chungtuSelect.Ngay_Ghi_So);
          }
          this.soquyetdinh = new Date(this.chungtuSelect.NgayQD);
        });
    }


    setTimeout(() => {
      this.slTaiKhoanNH.focus();
    }, 1000);
    this.fn_fixcot();
  }
  fn_fixcot() {
    (window as any).timerTG(this.fixcot, 1500);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    }

    this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: this.namketoan, DonViId: this.donviid, UserName: this.username })
      .subscribe(response => {
        this.inputtaikhoans = response;
      });
    this.LoadCategory();

  }


  LoadCategory(): void {
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_hoatdong.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputhoatdongs = response;
    //  });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_cmmt.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputcmmts = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_mathongke.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputthongkes = response;
      });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_caphat.id, MaGiaoDien: '', DonViId: this.donviid })
    //    .subscribe(response => {
    //      this.inputcaphats = response;
    //  });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nghiepvu.id, MaGiaoDien: '', DonViId: this.donviid })
    //    .subscribe(response => {
    //      this.inputnghiepvus = response;
    //  });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nganhang.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputnganhangs = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv21', { NhomId: '532A61EA-D765-844B-8CBF-E610B209E332', MaGiaoDien: '', DonViId: this.donviid, NamKeToan: this.namketoan, UserName: this.username })
      .subscribe(response => {
        this.inputkhachhangs = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nguonkinhphi.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputnguonkinhphis = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2',{NhomId:Lists_chuong.id,MaGiaoDien:'',DonViId:this.donviid})
    .subscribe(response => {
        this.inputchuongs = response;
    });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_loaikhoan.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputloaikhoans = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_tieumuc.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputtieumucs = response;
      });
    this.repo.postRequest('api/doituong/dstiente', { DonViId: this.donviid })
      .subscribe(response => {
        this.inputloaitiens = response;
      });
  }

  @ViewChildren("myinput") divs: QueryList<ElementRef>;



  //----------event xử lý di chuyển Enter--------------------------------------
  tongtien: number = 0;
  public changeST(drow: any) {
    this.chungtuSelect.Tong_Tien = 0;
    this.chungtuSelect.ChiTiets.forEach(
      (item) => {
        console.log(item.So_Tien);
        this.chungtuSelect.Tong_Tien = this.chungtuSelect.Tong_Tien + (item.So_Tien === null ? 0 : item.So_Tien)
      }
    );
  }
  setComboFocus(hang: number, cot: number, luoi: number) {
    var tencombo: string = hang + '_' + cot + '_' + luoi;
    // console.log(tencombo);
    var ketqua = false;
    this.slcombo.forEach(
      (question, i, allQuestions) => {
        if (question.labelForId === tencombo) {
          ketqua = true;
          question.focus();
        }
      }
    );

    if (ketqua === false) {
      this.divs.forEach(
        (div) => {

          if (div.nativeElement.id === tencombo) {
            ketqua = true;
            div.nativeElement.focus();
          }

        }
      );
    }
  }
  keyLyDo(event: any) {
    if (event.which === 13) {
      //this.slTaiKhoanNo.focus();
      this.setComboFocus(0, 1, 1);
      event.preventDefault();
    }
  }
  keyTKPress(event: any) {
    if (event.which === 13) {
      this.slKhachHang.focus();
      event.preventDefault();
    }
  }
  keyDonViNhanPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanNH2.focus();
      event.preventDefault();
    }
  }

  maxcot: number = 11;

  keyComBoPress(event: any, hang: number, cot: number, luoi: number) {

    if (luoi === 2)
      this.maxcot = 7;
    if (luoi === 1)
      this.maxcot = 15;
    if (luoi === 3)
      this.maxcot = 13;
    if (event.which === 13) {
      cot = cot + 1;
      if (cot > this.maxcot) {
        hang = hang + 1;
        cot = 1;

        if (luoi === 3) {
          if (hang === this.chungtuSelect.DongThois.length) {
            this.AddRowNew(this.chungtuSelect.DongThois);
            (window as any).timerTG(this.fixcot, 1500);
            setTimeout(() => {
              this.setComboFocus(hang, cot, luoi);
              event.preventDefault();
            }, 1500);
          }
        }
        else {
          if (hang === this.chungtuSelect.ChiTiets.length) {
            this.AddRowNew(this.chungtuSelect.ChiTiets);
            (window as any).timerTG(this.fixcot, 1500);
            setTimeout(() => {
              this.setComboFocus(hang, cot, luoi);
              event.preventDefault();
            }, 1500);
          }
        }
      }
      this.setComboFocus(hang, cot, luoi);
      event.preventDefault();
    }
  }
  RowNewClick() {
    if (this.tabselected === 3) {
      this.AddRowNew(this.chungtuSelect.DongThois);
      this.fn_fixcot();
    }
    else {
      this.AddRowNew(this.chungtuSelect.ChiTiets);
      this.fn_fixcot();
    }
  }
  AddRowKep(index: string, luoi: number) {
    var row = this.chungtuSelect.ChiTiets[index];
    var sp = 'bottom';
    if (this.chungtuSelect.DongThois.length > 9)
      sp = 'top'
    this.chungtuSelect.DongThois.push({
      showpopup: sp, Tai_Khoan_No_Id: null, Tai_Khoan_Co_Id: null, SoCTG: row.SoCTG, NgayCTG: row.NgayCTG, Dien_Giai_Chi_Tiet: row.Dien_Giai_Chi_Tiet, So_Tien: row.So_Tien,
      Nguon_Id: row.Nguon_Id, Chuong_Id: row.Chuong_Id, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: row.Hinh_Thuc_Cap_Phat_Id, Nghiep_Vu_Id: row.Nghiep_Vu_Id,
      Ngan_Hang_Id: row.Ngan_Hang_Id, Ma_Thong_Ke_Id: row.Ma_Thong_Ke_Id, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: row.Hoat_Dong_Id, So_De_Nghi: row.So_De_Nghi, Ngay_De_Nghi: row.Ngay_De_Nghi
    });
    this.tabselected = 3;
  }
  AddRowNew(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Tai_Khoan_No_Id: row.Tai_Khoan_No_Id, Tai_Khoan_Co_Id: row.Tai_Khoan_Co_Id, SoCTG: row.SoCTG, NgayCTG: row.NgayCTG, Dien_Giai_Chi_Tiet: row.Dien_Giai_Chi_Tiet, So_Tien: null,
        Nguon_Id: row.Nguon_Id, Chuong_Id: row.Chuong_Id, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: row.Hinh_Thuc_Cap_Phat_Id, Nghiep_Vu_Id: row.Nghiep_Vu_Id,
        Ngan_Hang_Id: row.Ngan_Hang_Id, Ma_Thong_Ke_Id: row.Ma_Thong_Ke_Id, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: row.Hoat_Dong_Id, So_De_Nghi: row.So_De_Nghi, Ngay_De_Nghi: row.Ngay_De_Nghi
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Tai_Khoan_No_Id: null, Tai_Khoan_Co_Id: null, SoCTG: null, NgayCTG: null, Dien_Giai_Chi_Tiet: null, So_Tien: null,
        Nguon_Id: null, Chuong_Id: null, Loai_Khoan_Id: null, Tieu_Muc_Id: null, Hinh_Thuc_Cap_Phat_Id: null, Nghiep_Vu_Id: null,
        Ngan_Hang_Id: null, Ma_Thong_Ke_Id: null, CTMT_Id: null, Hoat_Dong_Id: null, So_De_Nghi: null, Ngay_De_nghi: null
      });

    }

  }

  //----------event các control------------------------------------------------------
  onDoiTuongChange($event) {
    if (typeof $event === "undefined") {
      this.chungtuSelect.Ten_Doi_Tuong = null;
    }
    else {
      this.chungtuSelect.Ten_Doi_Tuong = $event.Ten_Doi_Tuong;
      this.repo.getRequest("api/baselayout/ThongTinDoiTuong/" + $event.Id)
        .subscribe(response => {
          //console.log(response);
          this.chungtuSelect.So_Tai_Khoan = response.So_Tai_Khoan;
          this.chungtuSelect.Ten_Ngan_Hang = response.Ten_Ngan_Hang;
        });
    }
  }
  onTaiNoChange($event) {
    if (typeof $event === "undefined") {
      this.chungtuSelect.Ten_Ngan_Hang1 = null;
    }
    else
      this.chungtuSelect.Ten_Ngan_Hang1 = $event.Ten_Doi_Tuong;
  }
  onTKNH2Change($event) {
    if (typeof $event === "undefined") {
      this.chungtuSelect.Ten_Ngan_Hang2 = null;
    }
    else
      this.chungtuSelect.Ten_Ngan_Hang2 = $event.Ten_Doi_Tuong;
  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFnTKS(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Tai_Khoan.toLowerCase().startsWith(term);
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;

  AddDoiTuong(cobo: NgSelectComponent, hang: number, cot: number) {

    this.comboSeleted = cobo;
    console.log(cobo)

    cobo.close();
    this.rowSelected = this.chungtuSelect.ChiTiets[hang];
    this.doituongchungedit.loadDataInit(cobo.addTagText, null, this.donviid);
    this.mdDoiTuongChung.open();

  }
  AddNguoiNop(cobo: NgSelectComponent) {
    this.comboSeleted = cobo;
    cobo.close();
    this.mdLuaChon.open();
  }
  loaithem: number = 2;
  onLoaiNguoiNop(loai: number) {
    this.loaithem = loai;
    console.log(loai);
  }
  AddFormNguoiNop() {
    this.mdLuaChon.dismiss();
    if (this.loaithem === 2) {
      this.canboedit.loadDataInit(Lists_canbo.id, null, this.donviid);
      this.mdCanBo.open();
    }
    else {
      this.khachhangedit.loadDataInit(Lists_nhacungcap.id, null, this.donviid);
      this.mdKhachhang.open();
    }
  }
  AddTK1(cobo: NgSelectComponent) {
    this.comboSeleted = cobo;
    cobo.close();
    this.nganhangedit.loadDataInit(Lists_nganhang.id, null, this.donviid, -1);
    this.mdDoiTuongNH.open();
  }
  AddTK2(cobo: NgSelectComponent) {
    this.comboSeleted = cobo;
    cobo.close();
    this.nganhangedit.loadDataInit(Lists_nganhang.id, null, this.donviid, -2);
    this.mdDoiTuongNH.open();
  }
  choncamketchi() {
    this.loccamketedit.loadDataInit(this.donviid, this.username, this.namketoan);
    this.mdLocCamKet.open();
  }
  xoachoncamketchi() {
    this.chungtuSelect.Ma_CKC = null;
    this.chungtuSelect.CKC_Id = null;
  }
  AddCKC(ctiets: any, row: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'

    ctiets.push({
      showpopup: sp, Tai_Khoan_No_Id: null, Tai_Khoan_Co_Id: null, SoCTG: null, NgayCTG: null, Dien_Giai_Chi_Tiet: null, So_Tien: row.So_Duoc_Giao_Du_Toan,
      Nguon_Id: row.Nguon_Id, Chuong_Id: null, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: null, Nghiep_Vu_Id: null,
      Ngan_Hang_Id: null, Ma_Thong_Ke_Id: null, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: null, So_De_Nghi: null, Ngay_De_nghi: null
    });

  }
  //------------------------------------
  saveModalCKC(doituong: any) {
    this.mdLocCamKet.dismiss();
    if (doituong != null && doituong.ckc != null) {
      this.chungtuSelect.Ma_CKC = doituong.ckc.Ma_Chung_Tu;
      this.chungtuSelect.CKC_Id = doituong.ckc.Id;

      this.chungtuSelect.ChiTiets = [];

      doituong.data.forEach(
        (item) => {
          if (this.chungtuSelect.ChiTiets.length === 0)
            this.AddCKC(this.chungtuSelect.ChiTiets, item);
          else {
            var bl: boolean = true;
            this.chungtuSelect.ChiTiets.forEach(
              (dk) => {
                if (item.Nguon_Id === dk.Nguon_Id && item.Loai_Khoan_Id === dk.Loai_Khoan_Id && item.Tieu_Muc_Id === dk.Tieu_Muc_Id && item.CTMT_Id === dk.CTMT_Id) {
                  bl = false;
                }
              }
            );
            if (bl)
              this.AddCKC(this.chungtuSelect.ChiTiets, item);
          }
        }
      );
    }
    console.log(doituong);
  }
  saveModalKhacHang(doituong: any) {
    this.mdKhachhang.dismiss();

    this.inputkhachhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputkhachhangs = this.inputkhachhangs.slice();

    this.chungtuSelect.Doi_Tuong_Id = doituong.Id;
    this.tendoituong = doituong.Ten_Doi_Tuong;
  }
  saveModalCanBo(doituong: any) {
    this.mdCanBo.dismiss();
    this.inputkhachhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputkhachhangs = this.inputkhachhangs.slice();

    this.chungtuSelect.Doi_Tuong_Id = doituong.Id;
    this.tendoituong = doituong.Ten_Doi_Tuong;
  }
  saveModalNganHang(doituong: any) {

    this.mdDoiTuongNH.dismiss();
    this.inputnganhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputnganhangs = this.inputnganhangs.slice();
    if (doituong.CallForm === -1) {
      this.chungtuSelect.Tai_Khoan_Ngan_Hang1_Id = doituong.Id;
      this.chungtuSelect.Ten_Ngan_Hang1 = doituong.Ten_Doi_Tuong;
    }
    if (doituong.CallForm === -2) {
      this.chungtuSelect.Tai_Khoan_Ngan_Hang2_Id = doituong.Id;
      this.chungtuSelect.Ten_Ngan_Hang2 = doituong.Ten_Doi_Tuong;
    }
    

  }
  saveModal(doituong: any) {
    console.log(doituong);
    this.mdDoiTuongChung.dismiss();

    if (doituong != null && Lists_hoatdong.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputhoatdongs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputhoatdongs = this.inputhoatdongs.slice();
      this.rowSelected.Hoat_Dong_Id = doituong.Id;
    }
    if (doituong != null && Lists_cmmt.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputcmmts.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputcmmts = this.inputcmmts.slice();
      this.rowSelected.CTMT_Id = doituong.Id;
    }
    if (doituong != null && Lists_mathongke.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputthongkes.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputthongkes = this.inputthongkes.slice();
      this.rowSelected.Ma_Thong_Ke_Id = doituong.Id;
    }
    if (doituong != null && Lists_caphat.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputcaphats.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputcaphats = this.inputcaphats.slice();
      this.rowSelected.Hinh_Thuc_Cap_Phat_Id = doituong.Id;
    }
    if (doituong != null && Lists_nghiepvu.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputnghiepvus.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputnghiepvus = this.inputnghiepvus.slice();

      this.rowSelected.Nghiep_Vu_Id = doituong.Id;
    }
    if (doituong != null && this.nhomnguonid === doituong.Nhom_Doi_Tuong_ID) {

      this.inputnguonkinhphis.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputnguonkinhphis = this.inputnguonkinhphis.slice();

      this.rowSelected.Nguon_Id = doituong.Id;
    }
    if (doituong != null && this.nhomloaikhoanid === doituong.Nhom_Doi_Tuong_ID) {

      this.inputloaikhoans.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputloaikhoans = this.inputloaikhoans.slice();
      this.rowSelected.Loai_Khoan_Id = doituong.Id;
    }
    if (doituong != null && this.nhomchuongid === doituong.Nhom_Doi_Tuong_ID) {

      this.inputchuongs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputchuongs = this.inputchuongs.slice();
      this.rowSelected.Chuong_Id = doituong.Id;
    }
    if (doituong != null && this.nhomtieumucid === doituong.Nhom_Doi_Tuong_ID) {

      this.inputtieumucs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputtieumucs = this.inputtieumucs.slice();
      this.rowSelected.Tieu_Muc_Id = doituong.Id;
    }
    this.comboSeleted.focus();
  }
  deleterow(index: string) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.chungtuSelect.ChiTiets.splice(index, 1);
        }
      });


  }
  public savectu() {


    //if (this.namketoan !== this.ngayghiso.getFullYear()) {
    //  swal('Cảnh báo!', "Ngày hạch toán nằm ngoài năm kế toán!!!", 'warning');
    //  return;
    //}
    if (this.chungtuSelect.Dien_Giai === null || this.chungtuSelect.Dien_Giai === '') {
      swal('Cảnh báo!', "Bạn chưa nhập diễn giải", 'warning');
      return;
    }

    for (let i = 0; i < this.chungtuSelect.ChiTiets.length; i++) {
      var row = this.chungtuSelect.ChiTiets[i];
      if (!this.datecheck(row.NgayCTG)) {
        swal('Cảnh báo!', "Ngày chứng từ gốc không hợp lệ", 'warning');
        this.setComboFocus(i, 2, 1);
        return;
      }
      if (!this.datecheck(row.Ngay_De_Nghi)) {
        swal('Cảnh báo!', "Ngày đề nghị không hợp lệ", 'warning');
        this.setComboFocus(i, 4, 1);
        return;
      } 
    }

    if (this.namketoan !== this.ngayghiso.getFullYear()) {
      //swal('Cảnh báo!', "Ngày hạch toán nằm ngoài năm kế toán!!!", 'warning');
      //return;
      swal({
        title: 'Ngày hạch toán nằm ngoài năm kế toán. Bạn muốn tiếp tục lưu không?',
        text: 'Dữ liệu sẽ được lưu vào năm ' + this.ngayghiso.getFullYear().toString() + '. Vui lòng chọn năm ' + this.ngayghiso.getFullYear().toString() + ' sau khi lưu để nhìn thấy chứng từ',
        icon: "warning",
        buttons: {
          cancel: {
            text: 'Hủy bỏ',
            value: false,
            visible: true,
          },
          confirm: {
            text: 'Đồng ý',
            value: true,
            visible: true,
            className: "bg-danger",
            closeModal: true
          }
        }
      })
        .then(willDelete => {
          if (willDelete) {

            /// bắt đầu
            if (this.chungtuSelect.Ho_Ten == null || this.chungtuSelect.Ho_Ten == "")
              this.chungtuSelect.Ho_Ten = this.chungtuSelect.Ten_Doi_Tuong;

            this.chungtuSelect.Ngay_Ghi_So_S = this.ngayghiso.getDate() + '/' + (this.ngayghiso.getMonth() + 1) + '/' + this.ngayghiso.getFullYear();
            this.chungtuSelect.Ngay_Chung_Tu_S = this.ngaychungtu.getDate() + '/' + (this.ngaychungtu.getMonth() + 1) + '/' + this.ngaychungtu.getFullYear();
            this.chungtuSelect.NgayQD_S = this.soquyetdinh.getDate() + '/' + (this.soquyetdinh.getMonth() + 1) + '/' + this.soquyetdinh.getFullYear();
            this.chungtuSelect.Ngay_Ghi_So = this.ngayghiso;
            this.chungtuSelect.Ngay_Chung_Tu = this.ngaychungtu;
            $('#loading').show();
            this.repo.postRequest("api/chungtu/addorupdate_ctuv2", this.chungtuSelect)
              .subscribe(response => {
                console.log(response);
                $('#loading').hide();
                if (response.Status === "OK") {
                  this.chungtuSelect.Id = response.Data.Id
                  this.chungtuSelect.Ma_Lien_Quan = response.Data.Ma_Lien_Quan
                  this.chungtuSelect.Lien_Quan_Id = response.Data.Lien_Quan_Id
                  this.chungtuSelect.Giao_Dich_Id = null;
                  this.save.emit(this.chungtuSelect);
                }

                else
                  swal('Cảnh báo!', response.Status, 'warning');
              });
            // kết thúc

          }
        });
    } else {
      /// bắt đầu
      if (this.chungtuSelect.Ho_Ten == null || this.chungtuSelect.Ho_Ten == "")
        this.chungtuSelect.Ho_Ten = this.chungtuSelect.Ten_Doi_Tuong;

      this.chungtuSelect.Ngay_Ghi_So_S = this.ngayghiso.getDate() + '/' + (this.ngayghiso.getMonth() + 1) + '/' + this.ngayghiso.getFullYear();
      this.chungtuSelect.Ngay_Chung_Tu_S = this.ngaychungtu.getDate() + '/' + (this.ngaychungtu.getMonth() + 1) + '/' + this.ngaychungtu.getFullYear();
      this.chungtuSelect.NgayQD_S = this.soquyetdinh.getDate() + '/' + (this.soquyetdinh.getMonth() + 1) + '/' + this.soquyetdinh.getFullYear();
      this.chungtuSelect.Ngay_Ghi_So = this.ngayghiso;
      this.chungtuSelect.Ngay_Chung_Tu = this.ngaychungtu;
      $('#loading').show();
      this.repo.postRequest("api/chungtu/addorupdate_ctuv2", this.chungtuSelect)
        .subscribe(response => {
          console.log(response);
          $('#loading').hide();
          if (response.Status === "OK") {
            this.chungtuSelect.Id = response.Data.Id
            this.chungtuSelect.Ma_Lien_Quan = response.Data.Ma_Lien_Quan
            this.chungtuSelect.Lien_Quan_Id = response.Data.Lien_Quan_Id
            this.chungtuSelect.Giao_Dich_Id = null;
            this.save.emit(this.chungtuSelect);
          }

          else
            swal('Cảnh báo!', response.Status, 'warning');
        });
            // kết thúc
    }

   

  }
  closeModal() {
    this.save.emit(null);
  }
  //-------------ham tiện ích---------------------------------------
  datecheck(conformedValue) {
    if (conformedValue == null || conformedValue === "")
      return true;
    const maxValueMonth = [31, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    const formatOrder = ['yyyy', 'yy', 'mm', 'dd', 'HH', 'MM', 'SS']
    var dateFormat: String = 'dd/mm/yyyy';
    var maxYear: number = 9999
    var minYear: number = 1;
    const dateFormatArray = dateFormat.split(/[^dmyHMS]+/).sort((a, b) => formatOrder.indexOf(a) - formatOrder.indexOf(b))

    const indexesOfPipedChars = []
    const maxValue = { 'dd': 31, 'mm': 12, 'yy': 99, 'yyyy': maxYear, 'HH': 23, 'MM': 59, 'SS': 59 }
    const minValue = { 'dd': 1, 'mm': 1, 'yy': 0, 'yyyy': minYear, 'HH': 0, 'MM': 0, 'SS': 0 }
    const conformedValueArr = conformedValue.split('')

    // Check first digit
    dateFormatArray.forEach((format) => {
      const position = dateFormat.indexOf(format)
      const maxFirstDigit = parseInt(maxValue[format].toString().substr(0, 1), 10)

      if (parseInt(conformedValueArr[position], 10) > maxFirstDigit) {
        conformedValueArr[position + 1] = conformedValueArr[position]
        conformedValueArr[position] = 0
        indexesOfPipedChars.push(position)
      }
    })

    // Check for invalid date
    let month = 0
    const isInvalid = dateFormatArray.some((format) => {
      const position = dateFormat.indexOf(format)
      const length = format.length
      const textValue = conformedValue.substr(position, length).replace(/\D/g, '')
      const value = parseInt(textValue, 10)
      if (format === 'mm') {
        month = value || 0
      }
      const maxValueForFormat = format === 'dd' ? maxValueMonth[month] : maxValue[format]
      if (format === 'yyyy' && (minYear !== 1 || maxYear !== 9999)) {
        const scopedMaxValue = parseInt(maxValue[format].toString().substring(0, textValue.length), 10)
        const scopedMinValue = parseInt(minValue[format].toString().substring(0, textValue.length), 10)
        return value < scopedMinValue || value > scopedMaxValue
      }
      return value > maxValueForFormat || (textValue.length === length && value < minValue[format])
    })

    if (isInvalid) {
      return false
    }

    return true;
  }
  export(kieuin, loaiphieu) {
    //loaiphieu=1 là in phiếu thu
    //loaiphieu=2 là in phiếu chi
    //loaiphieu=3 là nhập kho
    //loaiphieu=4 là xuất kho
    //loaiphieu=5 là chứng từ kế toán
    //loaiphieu=6 là hóa đơn bán hàng
    //loaiphieu=7 là biên lại thu tiền
    //loaiphieu=8 là giấy đề nghị thanh toán
    //loaiphieu=9 là bảng kê đề nghị thanh toán
    if (loaiphieu == null || loaiphieu == "") {
      swal('Cảnh báo!', 'Chưa chọn loại phiếu để in!.', 'warning');
      return;
    }
    $('#loading').show();
    let data = {
      Id: BaoCao.BC05_PhieuChungTu,
      Type: kieuin,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , IdChungTu: this.chungtuSelect.Id
        , LoaiPhieu: loaiphieu

      })
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          $('#loading').hide();
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "phieu_chung_tu.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }

  }

  save02a(doituong: any) {
    this.modalthamsogiayrutdutoan02a.dismiss();
    this.modalthamsogiayrutdutoan02b.dismiss();
  }
  giayrutdutoan02a() {
    this.dtthamsogiayrutdutoan02aedit.loadDataInit(this.chungtuSelect.Id, this.currentUser.id_don_vi);
    this.modalthamsogiayrutdutoan02a.open();
  }
  giayrutdutoan02b() {
    this.dtthamsogiayrutdutoan02bedit.loadDataInit(this.chungtuSelect.Id, this.currentUser.id_don_vi);
    this.modalthamsogiayrutdutoan02b.open();
  }

  savebangkethanhtoan(doituong: any) {
    this.modalthamsobangkethanhtoan_tt39.dismiss();
  }
  bangkethanhtoan_tt39() {
    this.dtbangkethanhtoan_tt39edit.loadDataInit(this.chungtuSelect.Id, this.currentUser.id_don_vi);
    this.modalthamsobangkethanhtoan_tt39.open();
  }

}
export interface Idata {
  Id: string,
  Ten: string,
  Dien_Thoai: string,
  Dia_Chi: string,
  Email: string,
  GhiChu: string,
  Created: Date,
  CreatedBy: string,
  Modified: Date,
  ModifiedBy: string
}
